export const LOAD_AUTOMATIONS_REQUEST = "LOAD_AUTOMATIONS_REQUEST";
export const LOAD_AUTOMATIONS_SUCCESS = "LOAD_AUTOMATIONS_SUCCESS";
export const LOAD_AUTOMATIONS_FAILURE = "LOAD_AUTOMATIONS_FAILURE";

export const CREATE_AUTOMATION_REQUEST = "CREATE_AUTOMATION_REQUEST";
export const CREATE_AUTOMATION_SUCCESS = "CREATE_AUTOMATION_SUCCESS";
export const CREATE_AUTOMATION_FAILURE = "CREATE_AUTOMATION_FAILURE";